export const DEFAULT_CRM_TOKEN = 'i7ibzzqwvj';
export const brandLogo = `${window.assetsLocation}/images/ripon_logo_new.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/ripon_banner_2.jpeg`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['15'];
export const faqArticleIds = ['16', '14', '13', '12', '11', '10', '9', '8', '7', '6', '5', '4', '3'];
// Get CRM token from environment variable or use default
export const getCrmToken = () => {
    return process.env.CRM_TOKEN || DEFAULT_CRM_TOKEN;
};
// Default logout redirect URL
const DEFAULT_LOGOUT_REDIRECT_URL = 'https://garysanitarydistrictin.comcate.com/en';
// Get logout redirect URL from environment variable or use default
export const getLogoutRedirectUrl = () => {
    const redirectUrl = process.env.LOGOUT_REDIRECT_URL || DEFAULT_LOGOUT_REDIRECT_URL;
    return encodeURIComponent(redirectUrl);
};
// Generate submit request URL with dynamic CRM token
export const getSubmitRequestUrl = () => {
    const token = getCrmToken();
    const logoutRedirect = getLogoutRedirectUrl();
    return `https://agency.comcate.com/private-submission/create?crm_token=${token}&logout_redirect_url=${logoutRedirect}`;
};
// Generate login to account URL with dynamic CRM token
export const getLoginToAccountUrl = () => {
    const token = getCrmToken();
    const logoutRedirect = getLogoutRedirectUrl();
    return `https://agency.comcate.com/private-submission/listing?crm_token=${token}&auth_enabled=true&logout_redirect_url=${logoutRedirect}`;
};
